import React, { useState } from 'react';
import 'twin.macro';
import {
  ArrowPathRoundedSquareIcon,
  ArrowTrendingDownIcon,
  ArrowTrendingUpIcon,
  ChatBubbleBottomCenterTextIcon,
  CheckIcon,
  ChevronDownIcon,
} from '@heroicons/react/24/outline';
import Button from 'components/Buttons/Button';
import InputGroup from 'components/Form/InputGroup';
import Popover from 'components/Popover';
import { useNextActions } from './useGetNextActions';
import { useTranslation } from 'react-i18next';

interface Props {
  startStream: ({
    text,
    adjustments,
  }: {
    text: string;
    adjustments?: string;
  }) => void;
  reset: () => void;
  text: string;
  livretEleveId: string;
  isFinish: boolean;
}

export function ReworkButton(props: Props) {
  const { reset, startStream, text } = props;
  const { t } = useTranslation(['common', 'carnet']);

  const { data } = useNextActions({
    livretEleveId: props.livretEleveId,
    remark: text,
    enabled: props.isFinish,
  });
  const [adjustments, setAdjustments] = useState<string | undefined>(undefined);
  return (
    <Popover placement="bottom-start" fill>
      <Popover.Button
        small
        icon={ArrowPathRoundedSquareIcon}
        rightIcon={ChevronDownIcon}
      >
        {t('common:buttons.adjust')}
      </Popover.Button>
      <Popover.Panel>
        {adjustments !== undefined ? (
          <div tw="p-4">
            <InputGroup
              label={t('carnet:howToImproveRemarks')}
              value={adjustments}
              autoFocus
              onChange={v => setAdjustments(v)}
            />
            <div tw="flex items-center gap-x-2 justify-end">
              <Button minimal onClick={() => setAdjustments(undefined)}>
                {t('common:buttons.cancel')}
              </Button>
              <Button
                icon={CheckIcon}
                onClick={() => {
                  reset();
                  startStream({ text, adjustments });
                }}
              >
                {t('common:buttons.validate')}
              </Button>
            </div>
          </div>
        ) : (
          <div tw="divide-y">
            <div>
              <Button
                fill
                alignText="left"
                minimal
                icon={ArrowTrendingUpIcon}
                tw="rounded-none"
                onClick={() => {
                  reset();
                  startStream({
                    adjustments: 'Fais une remarque plus longue',
                    text,
                  });
                }}
              >
                {t('common:buttons.longer')}
              </Button>
            </div>
            <div>
              <Button
                fill
                alignText="left"
                minimal
                icon={ArrowTrendingDownIcon}
                tw="rounded-none"
                onClick={() => {
                  reset();
                  startStream({
                    text,
                    adjustments: 'La remarque doit être plus courte',
                  });
                }}
              >
                {t('common:buttons.shorter')}
              </Button>
            </div>
            <div>
              <Button
                fill
                minimal
                tw="rounded-none"
                icon={ChatBubbleBottomCenterTextIcon}
                alignText="left"
                onClick={e => {
                  e.stopPropagation();
                  e.preventDefault();
                  setAdjustments('');
                }}
              >
                {t('common:buttons.addPrecisions')}
              </Button>
            </div>
            {(data || []).map(({ label, prompt }) => (
              <div>
                <Button
                  fill
                  minimal
                  tw="rounded-none"
                  icon={ArrowPathRoundedSquareIcon}
                  alignText="left"
                  onClick={() => {
                    reset();
                    startStream({ text, adjustments: prompt });
                  }}
                >
                  {label}
                </Button>
              </div>
            ))}
          </div>
        )}
      </Popover.Panel>
    </Popover>
  );
}
